/**
 * Decode JWT exp without verifying signature (client-side expiry check only).
 */
export function isAccessTokenExpired(token: string | null | undefined, leewaySeconds = 60): boolean {
  if (!token) return true;
  try {
    const payloadPart = token.split('.')[1];
    if (!payloadPart) return true;
    const payload = JSON.parse(atob(payloadPart.replace(/-/g, '+').replace(/_/g, '/')));
    const exp = typeof payload.exp === 'number' ? payload.exp : null;
    if (!exp) return false;
    return Date.now() / 1000 >= exp - leewaySeconds;
  } catch {
    return true;
  }
}
